/*
 * @package           Zorg CMS
 * @author            Dru
 * @copyright         Copyright (c) 2008 - 2023, Belder Interactive s.a.s.
 * @link              https://www.belder.com
 * @version           3.2
 */

let fn_font = (+localStorage.getItem('fn_zoom')) || 1;
setZoom(fn_font);

function setZoom(zoom) {
	zoom = +zoom;
	if (zoom <= 1) {
		document.body.style.removeProperty('zoom');
	} else {
		document.body.style.setProperty('zoom', zoom);
	}
}

let zooms = [1, 1.2, 1.5];

document.getElementById('fn_font').addEventListener('click', () => {
	fn_font = zooms[zooms.indexOf(fn_font) + 1] || 1;
	localStorage.setItem('fn_font', fn_font);
	setZoom(fn_font);
});

let fn_contrast = localStorage.getItem('fn_contrast') || false;
if (fn_contrast) document.body.classList.add('contrast');

document.getElementById('fn_contrast').addEventListener('click', () => {
	fn_contrast = !fn_contrast;
	fn_contrast ? localStorage.setItem('fn_contrast', '1') : localStorage.removeItem('fn_contrast');
	document.body.classList[fn_contrast ? 'add' : 'remove']('contrast');
});

let fn_link = localStorage.getItem('fn_link') || false;
if (fn_link) document.body.classList.add('link');
document.getElementById('fn_link').addEventListener('click', () => {
	fn_link = !fn_link;
	fn_link ? localStorage.setItem('fn_link', '1') : localStorage.removeItem('fn_link');
	document.body.classList[fn_link ? 'add' : 'remove']('link');
});
